import { CalculatorResultsStore } from "../Store/CalculatorResultsContext";
import { none, some } from "fp-ts/lib/Option";
import { CalculatorInputs } from "../../model/CalculatorInputs";
import { Either, fold } from "fp-ts/lib/Either";
import { pipe } from 'fp-ts/lib/pipeable';
import { calculate } from "../../api/CalculatorApi";
import { CalculatorResponse } from "../../model/CalculatorResponse";
import { CalculatorConfig } from "../../model/CalculatorConfig";
import { analyticsToolCompleteEvent, analyticsCustomRangeEvent, analyticsErrorEvent } from "../../utils/Analytics";

export const fetchResults = async (inputs: CalculatorInputs, config: CalculatorConfig,
    resultsStore: CalculatorResultsStore) => {

    resultsStore.setResults(none);
    resultsStore.setLoading(true);
    const realResult: Either<Error, CalculatorResponse> = await calculate(inputs, config);
    resultsStore.setConfig(config);
    resultsStore.setLoading(false);
    pipe(
        realResult,
        fold(
            (err) => {
                resultsStore.setResults(none);
                resultsStore.setError(some(err.toString()));
                analyticsErrorEvent("ToolError", err.toString());
            },
            (response) => {
                resultsStore.setError(none);
                resultsStore.setResults(some((response)));  
                analyticsToolCompleteEvent(inputs, config);
            }
        )
    );
}

/**
 * Here we want to load results for a custom year without interfering with the primary results display (or overwriting it if the second
 * service call fails). So we load and save the data to a separate variable, and if it is valid, we set the primary results without
 * setting it to none in the interim.
 * @param inputs 
 * @param config 
 * @param resultsStore 
 */
export const fetchSecondaryResults = async (forStrategyIndex: number, inputs: CalculatorInputs, config: CalculatorConfig,
    resultsStore: CalculatorResultsStore) => {

    resultsStore.setSecondaryResults(none);
    resultsStore.setLoading(true);
    const realResult: Either<Error, CalculatorResponse> = await calculate(inputs, config);
    resultsStore.setConfig(config);
    resultsStore.setLoading(false);
    pipe(
        realResult,
        fold(
            (err) => {
                resultsStore.setSecondaryResults(none);
                resultsStore.setError(some(err.toString()));
                analyticsErrorEvent("ToolErrorCustomRange", err.toString());
            },
            (response) => {
                resultsStore.setError(none);
                resultsStore.setSecondaryResults(some((response)));                
                resultsStore.setResults(some((response)));           
                analyticsCustomRangeEvent(forStrategyIndex, inputs, config);
            }
        )
    );
}